import { render, staticRenderFns } from "./Wortmeldeliste.vue?vue&type=template&id=f4d53a3c&scoped=true&"
import script from "./Wortmeldeliste.vue?vue&type=script&lang=js&"
export * from "./Wortmeldeliste.vue?vue&type=script&lang=js&"
import style0 from "./Wortmeldeliste.vue?vue&type=style&index=0&id=f4d53a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d53a3c",
  null
  
)

export default component.exports